export enum DeviceType {
  PRINTF = 'PRINTF',
  ITALRETAIL = 'ITALRETAIL',
  CUSTOM = 'CUSTOM',
  EPSON_FP_81_90 = 'EPSON_FP_81_90',
  PRINTF_7 = 'PRINTF_7',
  ITALRETAIL_7 = 'ITALRETAIL_7',
  CUSTOM_7 = 'CUSTOM_7',
  EPSON_FP_81_90_7 = 'EPSON_FP_81_90_7',
}
